import { createThumbnailCache } from '@/views/image-generate/feishuThumbnailCache.cjs'
import { CDN_ORIGIN } from '@/utils/publicMediaUrl'

// Public 64px derivatives only. Keep loaded bytes across virtual rows/menu remounts.
// Active leases stay valid; inactive entries are reclaimed above 256 items / 8 MiB.
const cache = createThumbnailCache(256, 8 * 1024 * 1024)
const processes = new Set([
  'image/resize,m_lfit,w_64,h_64/quality,q_70/format,webp',
  'video/snapshot,t_0,f_jpg,w_64,h_0,m_fast'
])

export function isMentionThumbnailCacheable(source) {
  try {
    const url = new URL(source)
    return url.origin === CDN_ORIGIN && !url.username && !url.password && !url.hash &&
      [...url.searchParams.keys()].length === 1 && processes.has(url.searchParams.get('x-oss-process'))
  } catch (_) { return false }
}

export function acquireMentionThumbnail(source) {
  if (!isMentionThumbnailCacheable(source)) return null
  return cache.acquire(source, async signal => {
    // Existing service-worker/disk caching remains available after a page reload.
    const response = await fetch(source, { signal, mode: 'cors', credentials: 'omit', headers: { Accept: 'image/*' } })
    if (!response.ok) throw new Error(`Thumbnail request failed: ${response.status}`)
    const blob = await response.blob()
    if (!blob.size || !blob.type.startsWith('image/')) throw new Error('Invalid thumbnail response')
    return blob
  })
}

export const peekMentionThumbnail = source => cache.peek(source)
